/* src/modules/auth/action_types.js */

export const validateTokenTypes = [
  'VALIDATE_TOKEN',
  'VALIDATE_TOKEN_SUCCESS',
  'VALIDATE_TOKEN_FAIL',
];

export const loginTypes = [
  'LOGIN',
  'LOGIN_SUCCESS',
  'LOGIN_FAIL',
];

export const login2faTypes = [
  'LOGIN2fa',
  'LOGIN2fa_SUCCESS',
  'LOGIN2fa_FAIL',
];

export const verify2faTypes = [
  'VERIFY2fa',
  'VERIFY2fa_SUCCESS',
  'VERIFY2fa_FAIL',
];

export const fetchUserTypes = [
  'FETCH_USER',
  'FETCH_USER_SUCCESS',
  'FETCH_USER_FAIL',
];

export const forgotPasswordTypes = [
  'FORGOT_PASSWORD',
  'FORGOT_PASSWORD_SUCCESS',
  'FORGOT_PASSWORD_FAIL',
];

export const SELECT_UNIVERSITY = 'SELECT_UNIVERSITY';
export const SELECT_ORGANIZATION = 'SELECT_ORGANIZATION';
export const CLEAR_AUTH = 'CLEAR_AUTH';



// WEBPACK FOOTER //
// ./src/modules/auth/action_types.js